export default __webpack_public_path__ + "b1adc1655f25b7273f11bb2d05b66772.png";